<template>
  <div>
    <div class="parent" :style="style">
      <v-card>
        <div class="parent-side">
          <v-card-title class="info-title">
            <div class="text-center">
              {{ ayinNameh.name }}
            </div>
          </v-card-title>
          <div>
            <app-row title="مقطع:" :value="ayinNameh.maqtaString" />
            <app-row title="جنسیت:" :value="ayinNameh.jensiatString" />
            <app-row title="وضعیت:" :value="ayinNameh.active" />
            <v-row align="center">
              <v-col id="buttonRow">
                <v-btn
                  class="grid"
                  color="green white--text"
                  rounded
                  @click="$emit('downloadClicked', ayinNameh.serial)"
                  style="margin-left: 5px;"
                  v-if="ayinNameh.fileSerial"
                >
                  {{ "دانلود" }}
                </v-btn>
                <v-btn
                  class="grid"
                  color="green white--text"
                  rounded
                  @click="$emit('clicked', ayinNameh.serial)"
                >
                  {{ "مشاهده" }}
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
export default {
  props: ["ayinNameh", "index", "selectedIndex"],
  components: {
    appRow: DetailRow,
  },
  data: () => ({
    show: false,
  }),
  methods: {
    showAyinDetail() {
      this.$emit("clicked", this.index);
    },
    showAyinDownload() {
      this.$emit("downloadClicked", this.index);
    },
  },
  computed: {
    showSelectedDetails() {
      if (this.showDetails && this.selectedIndex === this.index) {
        return true;
      }
      return false;
    },
    style() {
      var res = "";
      if (this.$store.getters.isMobile) {
        res = "width: 100%";
      } else {
        res = "width: calc(100% - 300px)";
      }
      return res;
    },
  },
  created() {},
};
</script>
<style scoped>
.v-card__title {
  border-radius: 15px 15px 0px 0px !important;
  width: auto;
}

.v-card {
  display: flex !important;
}
.rotated {
  transform-origin: 113px 113px;
  width: 226px;
}
.parent-side {
  border-radius: 15px 15px 0px 15px !important;
  width: 100%;
}
.flex-card {
  display: flex;
  direction: column;
  justify-content: center;
  align-items: center;
}
#textWrap {
  line-break: anywhere;
  text-align: center;
  text-wrap: wrap;
  margin: auto;
}
#buttonRow {
  margin-bottom: 10px;
  text-align: left;
  margin-left: 10px;
}
</style>
